import axios from "axios";
import { getUserPlatform } from "../utils/device";

export const getToroxGamingOffers = async (country) => {
    const { data } = await axios.get('api/toroxoffers/gaming', {
        headers: {
            "Content-Type": 'application/json'
        },
        params: {
            country: country,
            platform: getUserPlatform()
        }
    });
    return data;
};

export const getToroxOffers = async (country) => {
    const { data } = await axios.get('api/toroxoffers/offers', {
        headers: {
            "Content-Type": 'application/json'
        },
        params: {
            country: country,
            platform: getUserPlatform()
        }
    });
    return data;
};

// Absolute URL to our backend click endpoint, which generates the Torox
// tracking URL at click moment (never cached) and 302s to it. Works for
// card links and desktop QR codes. MUST be absolute: QR scanners can't
// resolve relative URLs (phones misread them as phone numbers).
// Handles dev (http://localhost:5001) and prod (same-origin '/').
export const buildToroxClickLink = (userId, country, campaignId) => {
    const base = (axios.defaults.baseURL || '').replace(/\/$/, '');
    const origin = base || (typeof window !== 'undefined' ? window.location.origin : '');
    return `${origin}/api/toroxoffers/click?userId=${encodeURIComponent(userId)}&country=${encodeURIComponent(country || 'US')}&campaign_id=${encodeURIComponent(campaignId)}`;
};

// Backend already returns normalized offers; adapt to card props.
export const toCardOffer = (offer, userId, country) => ({
    id: offer.id,
    title: offer.title,
    description: offer.description,
    devices: offer.devices,
    imageUrl: offer.imageUrl,
    link: buildToroxClickLink(userId, country, offer.campaign_id),
    reward: offer.reward,
    events: offer.events,
});
